import React, { useState } from 'react';
import ArticleReviewerProgressReport from './ArticleReviewerProgressReport';
import { ReviewerDistributionTab } from './ReviewerDistributionTab';
import {
  PRIMARY,
  TEXT_MUTED,
  BORDER_LIGHT,
} from '../legacy-ball/table-management/designTokens';

// ── Types ─────────────────────────────────────────────────────

type EditorialSubView = 'editorial-review' | 'reviewer-distribution';

const SUB_VIEWS: { key: EditorialSubView; label: string }[] = [
  { key: 'editorial-review', label: 'Editorial Review' },
  { key: 'reviewer-distribution', label: 'Reviewer Distribution' },
];

// ── Styles ────────────────────────────────────────────────────

const styles: Record<string, React.CSSProperties> = {
  container: {
    marginTop: '0.5rem',
  },
  subNav: {
    display: 'flex',
    gap: '0',
    marginBottom: '1rem',
    borderBottom: `1px solid ${BORDER_LIGHT}`,
  },
  subTab: {
    padding: '0.5rem 1rem',
    fontSize: '0.85rem',
    fontWeight: 500,
    cursor: 'pointer',
    border: 'none',
    backgroundColor: 'transparent',
    color: TEXT_MUTED,
    borderBottom: '2px solid transparent',
    marginBottom: '-1px',
    transition: 'color 0.2s, border-color 0.2s',
  },
  subTabActive: {
    padding: '0.5rem 1rem',
    fontSize: '0.85rem',
    fontWeight: 600,
    cursor: 'pointer',
    border: 'none',
    backgroundColor: 'transparent',
    color: PRIMARY,
    borderBottom: `2px solid ${PRIMARY}`,
    marginBottom: '-1px',
    transition: 'color 0.2s, border-color 0.2s',
  },
};

// ── Component ─────────────────────────────────────────────────

export function EditorialTab() {
  const [activeView, setActiveView] = useState<EditorialSubView>('editorial-review');

  return (
    <div style={styles.container}>
      <nav style={styles.subNav} aria-label="Editorial views">
        {SUB_VIEWS.map((view) => (
          <button
            key={view.key}
            style={activeView === view.key ? styles.subTabActive : styles.subTab}
            onClick={() => setActiveView(view.key)}
            aria-current={activeView === view.key ? 'page' : undefined}
          >
            {view.label}
          </button>
        ))}
      </nav>

      {activeView === 'editorial-review' && <ArticleReviewerProgressReport />}
      {activeView === 'reviewer-distribution' && <ReviewerDistributionTab />}
    </div>
  );
}
